import { Component } from '@angular/core';
import { Layout } from 'app/views/presentations/layouts/layout';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';

@Component({
    selector: `psm-two-sections-vertical-layout-component`,
    templateUrl: 'twoSectionsVerticalLayout.component.html',
    styleUrls: ['../layout.component.scss']
})

export class TwoSectionsVerticalLayoutComponent extends LayoutComponent { }

export class TwoSectionsVerticalLayout extends Layout {
    public type = 'TwoSectionsVerticalLayout';
    public componentType = TwoSectionsVerticalLayoutComponent;
    public numberOfSections = 2;
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/twoSectionsVerticalLayout/twoSectionsVerticalLayout.component.ts